import {ParentModule} from './../../../A2-utils/ParentClass/parent-module';
import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Subscription } from 'rxjs/Subscription';
import { ReservationService } from '../../reservations.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-change-time',
  templateUrl: 'change-time.component.html',
  styleUrls: ['./change-time.component.scss'],
})
export class ChangeTimeComponent extends ParentModule implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  formChangeTime: FormGroup;
  reservationForm: any;
  modelDatePicker: any;

  constructor(
    private fb: FormBuilder,
    private reservationService: ReservationService,
    protected Inject: Injector,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    super('app-edit-reservation-form', Inject);
    this.createForm();
  }

  ngOnInit() {
    this.subscribeObservables();
    this.validateRequiredDate();
  }

  subscribeObservables() {
    this.subscriptions.push(
      this.reservationService.reservationData$.subscribe((resp) => {
        if (resp) {
          this.reservationForm = resp;
          this.formChangeTime.patchValue({
            tripid: resp.tripid,
            pickup: resp.pickup,
            appointment: resp.appointment,
          });
        }
      })
    );

    this.subscriptions.push(
      this.reservationService.standingOrderDate$.subscribe((resp) => {
        if (resp) {
          this.assignDateToDatePicker(
            this.getDateFormatted(resp.beginDate),
            this.getDateFormatted(resp.endDate)
          );
        }
      })
    );
  }

  createForm() {
    this.formChangeTime = this.fb.group({
      tripid: [''],
      startdatechanges: ['', Validators.required],
      enddatechanges: ['', Validators.required],
      pickup: ['', Validators.required],
      appointment: ['', Validators.required],
      notepickup: [''],
      notedropoff: [''],
      notetrip: [''],
    });
  }

  assignDateToDatePicker(begin: any, end: any) {
    begin = moment(begin);
    end = moment(end);

    this.modelDatePicker = {
      beginDate: {
        year: begin.year(),
        month: begin.month() + 1,
        day: begin.date(),
      },
      endDate: {
        year: end.year(),
        month: end.month() + 1,
        day: end.date(),
      },
    };
  }

  timesChanged(event: any, field: string, nativeEvent?: any) {
    if (field === 'appointment') {
      if (nativeEvent) {
        if (nativeEvent.key !== 'Tab') {
          this.calculatePickup();
        }
      }
    }
  }

  calculatePickup() {
    const aptime = this.formChangeTime.get('appointment').value;
    const totalM = this.reservationForm.totalmiles;
    const calltypeid = this.reservationForm.calltypeid;
    if (aptime && totalM && calltypeid) {
      this.subscriptions.push(
        this.reservationService
          .getEstimatedPickup(calltypeid, totalM, aptime)
          .subscribe((data) => {
            if (
              data &&
              this.formChangeTime.get('pickup').value !== data.slice(0, 5)
            ) {
              this.sweetAlertHelper.createCustomAlert({
                type: 'warning',
                text: 'Want to modify Sched. PU',
                showCancelButton: true,
                cancelButtonText: 'No',
                allowOutsideClick: false,
                allowEnterKey: false,
              }).then((result: any) => {
                if (result.value) {
                  this.formChangeTime.patchValue({
                    pickup: data.slice(0, 5),
                  });
                }
              });
            } else {
              this.formChangeTime.patchValue({
                pickup: data.slice(0, 5),
              });
            }
          })
      );
    }
  }

  onChangeRangeDate(event: any) {
    if (event) {
      if (!event.formatted) {
        const startDate = `${event.beginDate.year}-${event.beginDate.month}-${event.beginDate.day}`;
        const endDate = `${event.endDate.year}-${event.endDate.month}-${event.endDate.day}`;
        this.setDateRange(startDate, endDate);
      } else {
        this.setDateRange(event.beginJsDate, event.endJsDate);
      }
    } else {
      this.modelDatePicker = null;
      this.formChangeTime.patchValue({
        startdatechanges: '',
        enddatechanges: '',
      });
      this.upDateValidateDate([Validators.required]);
    }
  }

  setDateRange(startDate, endDate) {
    this.formChangeTime.patchValue({
      startdatechanges: moment(startDate).format('MM-DD-YYYY'),
      enddatechanges: moment(endDate).format('MM-DD-YYYY'),
    });
  }

  save() {
    const formData = Object.assign({}, this.formChangeTime.getRawValue());
    if (formData.tripid) {
      this.subscriptions.push(
        this.reservationService.putTimeServiceSo(formData).subscribe(
          (resp) => {
            if (resp) {
              this.sweetAlertHelper.createCustomAlert({title: 'Successfully Updated!', text: resp.message, type: 'success'}).then(
                (result: any) => {
                  if (result.value) {
                    this.reservationService.saveEditTime$.emit(true);
                  }
                }
              );
            }
          },
          (error) => {
            this.sweetAlertHelper.createCustomAlert({title: 'Error!', text: error.message, type: 'error'});
          }
        )
      );
    }
  }

  cancel() {
    this.reservationService.saveEditTime$.emit(false);
  }

  validateRequiredDate() {
    if (!this.isAllowedAction('Allow So Changes By Date')) {
      this.upDateValidateDate(null);
    }
  }

  upDateValidateDate(isRequired) {
    this.formChangeTime.get('startdatechanges').setValidators(isRequired);
    this.formChangeTime.get('enddatechanges').setValidators(isRequired);
    this.formChangeTime.get('startdatechanges').updateValueAndValidity();
    this.formChangeTime.get('enddatechanges').updateValueAndValidity();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscriptions) => subscriptions.unsubscribe());
  }

  getDateFormatted(date: any) {
    const newDate = date.month + '-' + date.day + '-' + date.year;
    return new Date(newDate);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/change-time/change-time.component.ts